import { registerClienteEntranceResolver } from '@modules/navegacao-v2/utils/module-entrance'
import * as WSStore from './store'
import * as WSBackofficeStore from './store/backoffice'
import { resolveWsClienteEntrance } from './utils/cliente-entrance'

export function wsModule({store}) {
  store.registerModule('ws', {...WSStore, namespaced: true})
  store.registerModule('wsBackoffice', {...WSBackofficeStore, namespaced: true})
  registerClienteEntranceResolver('ws', resolveWsClienteEntrance)
}
